import { render } from "./index.vue?vue&type=template&id=e2bcec3a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e2bcec3a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e2bcec3a"

export default script